import {
    Component,
    ElementRef,
    forwardRef,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';
import { MODAL_EDITOR_TOKEN, ModalEditorBase } from '../../../classes/modal-editor-base';
import { InputFieldType } from '../../../types/input-field.type';

@Component({
    selector: 'ft-list-editor',
    templateUrl: './list-editor.component.html',
    styleUrls: ['list-editor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => ListEditorComponent)
        },
        {
            provide: MODAL_EDITOR_TOKEN,
            useExisting: ListEditorComponent
        }
    ]
})
export class ListEditorComponent extends ModalEditorBase implements OnChanges, OnInit {
    @ViewChild('input', { read: NgModel, static: false }) input: NgModel;
    @ViewChild('inputElement', { static: false }) inputElement: ElementRef;
    @Input() controlName = 'formControl';
    @Input() email: boolean;
    @Input() maxlength: number;
    @Input() minlength: number;
    @Input() min: number;
    @Input() max: number;
    @Input() pattern: string;
    @Input() patternValidationText: string;
    @Input() type: InputFieldType = 'text';
    @Input() formatter: (value: string) => string;
    @Input() placeholder = 'Add an item';
    @Input() listPlaceholder = 'No items have been added to this list';
    @Input() options: any[];
    @Input() bindValue: string;
    @Input() bindLabel: string;
    @Input() bindOptionValue: string;
    @Input() bindOptionLabel: string;
    @Input() addOnCLick: boolean;
    @Input() optionTpl: TemplateRef<any>;


    newValue: string;

    @Input() caseSensitive = false;
    @Input() allowDuplicates = false;
    hasDuplicatesError = false;


    constructor() {
        super();
    }

    addItem() {
        if (!this.input?.invalid && this.newValue) {
            this.validateDuplicates();

            if (!this.hasDuplicatesError) {
                this.value = [...this.value, this.formattedValue];
                if (!this.allowDuplicates && this.options?.length) {
                    this.options = this.options.filter(o => o[this.bindOptionValue || this.bindValue] !== this.newValue)
                }
                this.newValue = null;
            }
        }
    }

    get formattedValue() {
        const value = this.formatter ? this.formatter(this.newValue) : this.newValue;
        return !!this.bindValue ? { [this.bindValue]: value } : value;
    }

    validateDuplicates() {
        if (!this.allowDuplicates) {
            this.hasDuplicatesError = false;
            this.value?.forEach(item => {
                if (this.caseSensitive) {
                    if (this.bindValue ? (item[this.bindValue] === this.newValue[this.bindValue]) : (item === this.newValue)) {
                        this.hasDuplicatesError = true;
                    }
                } else {
                    if (this.bindValue ? (item[this.bindValue].toLowerCase() === this.formattedValue[this.bindValue].toLowerCase()) : (item.toLowerCase() === this.newValue.toLowerCase())) {
                        this.hasDuplicatesError = true;
                    }
                }
            });
        }
    }

    removeItem(itemIndex) {
        this.value = this.value.filter((val, index) => itemIndex !== index);
    }

    ngOnInit(): void {
        if (this.type === 'url') {
            this.patternValidationText = 'Value is not valid url.';
            this.pattern = 'https?://.+';
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!!changes.type) {
            this.email = changes.type.currentValue === 'email';
        }
    }

    onSelect(event) {
        console.log(event);
    }
}


